import React, { useEffect, useRef } from 'react'
import { NavLink } from 'react-router-dom'

import useTabs from './useTabs'

export interface TabTitleProps {
    id: string | number
    title: string | React.ReactElement
    initial?: boolean
    path?: string
    url?: string
    exact?: boolean
    isDisabled?: boolean
    tabTitleContainer?: any
    handleSetTabRow?: (id, index, row, isLeadingPos) => any
    index?: number
}

const TabTitle: React.FC<TabTitleProps> = ({
    tabTitleContainer,
    isDisabled = false,
    initial = false,
    exact = false,
    id,
    title,
    url,
    path,
    handleSetTabRow,
    index,
}) => {
    const tabsCtx = useTabs()

    const { current, setCurrent, registerTab, colors } = tabsCtx
    const ref = useRef(null)
    const active = id === current ? 'active' : ''

    useEffect(() => {
        registerTab({ id, title, path, exact, initial })
    }, [])

    useEffect(() => {
        if (ref.current && tabTitleContainer.height) {
            const tabNode = ref.current.getBoundingClientRect()
            const y = tabTitleContainer
            const titleBottomY = Math.ceil(tabTitleContainer.y + tabTitleContainer.height)
            const titleBottomX = Math.ceil(tabTitleContainer.x)
            const tabNodeBottomY = Math.ceil(tabNode.y + tabNode.height)
            const tabNodeBottomx = Math.ceil(tabNode.x)
            const rows = Math.floor(tabTitleContainer.height / tabNode.height)
            const row = Math.floor(tabNode.y / tabNode.height)
            const isLeadingPos = tabNodeBottomx === titleBottomX && titleBottomY === tabNodeBottomY
            handleSetTabRow(id, index, row, isLeadingPos)
        }
    }, [tabTitleContainer, ref.current])

    const handleClick = () => {
        if (isDisabled) {
            return
        }
        setCurrent(id)
    }

    let background = colors?.tabBackground ?? null
    let activeBorder

    if (active) {
        background = colors?.tabActiveBackground ?? null
        activeBorder = colors?.tabActiveBorder ?? null
    }

    const tabContainer = (
        <div
            ref={ref}
            className={`r-tab ${active} ${isDisabled ? 'r-state-disabled' : ''}`}
            style={{
                background: background,
                borderTopColor: activeBorder,
            }}
            onClick={handleClick}
        >
            <span className={'r-tab-text'}>{title}</span>
            <span className={'r-tab-angle'} />
        </div>
    )

    if (current === null) {
        // return null
    }

    if (url && !isDisabled) {
        const search = window.location.search || ''

        return (
            <NavLink className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} to={url + search}>
                {tabContainer}
            </NavLink>
        )
    }

    return tabContainer
}
export default TabTitle
//
// if (path) {
//   tab = (
//     <NavLink exact={exact} className={`r-tab`} activeClassName={'active'} to={path}>
//       <span className={'r-tab-text'}>{title}</span>
//     </NavLink>
//   )
// } else {
//   tab = (
//     <div className={`r-tab ${active}`} onClick={(e) => {}}>
//       <span className={'r-tab-text'}>{title}</span>
//     </div>
//   )
// }
